import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Menu } from '@mui/material'
import { MouseEvent, ReactNode, useState } from 'react'

const MenuButton = ({
  label,
  variant,
  children,
}: {
  label: string
  variant: 'text' | 'outlined' | 'contained'
  children: ReactNode[] | ReactNode
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const handleClose = () => setAnchorEl(null)

  return (
    <Box>
      <Button
        variant={variant}
        onClick={(event: MouseEvent<HTMLButtonElement>) => {
          setAnchorEl(event.currentTarget)
        }}
        endIcon={
          <Box width={18} display="flex" justifyContent="center">
            <FontAwesomeIcon
              icon={!!anchorEl ? faChevronDown : (faChevronRight as IconProp)}
              style={{ fontSize: 12 }}
            />
          </Box>
        }>
        {label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        {children}
      </Menu>
    </Box>
  )
}

export default MenuButton
